import React, { useMemo } from 'react'
import { connect } from 'react-redux'
import { getDistanceUnit, getOfferBasedLereState } from 'selectors/recommendations'
import YmalStickyFooter, { Props as YmalStickyFooterProps } from '../StickyFooter/YmalStickyFooter'
import uuidV4 from 'lib/uuidV4'
import TrackingContext, { TrackingProps } from 'contexts/trackingContext'
import { getListName } from 'analytics/enhanced-ecommerce'
import { ISO_DATE_FORMAT } from 'constants/dateFormats'
import moment from 'moment/moment'

interface OwnProps {
  pageSource: string
  seedOffer?: App.Offer
}

interface Props extends Omit<YmalStickyFooterProps, 'seedOffer'>, OwnProps {
  lereOfferCheckIn: string | undefined
  lereOfferCheckOut: string | undefined
  lereOfferDuration: number | undefined
}

function OfferYmalStickyFooter({ pageSource, lereOfferCheckIn, lereOfferCheckOut, lereOfferDuration, ...props }: Props) {
  const {
    lereVersion,
  } = props

  const stickyFooterTracking = useMemo<TrackingProps>(() => ({
    category: 'LERE',
    label: getListName('LERE', pageSource, 'Sticky Footer'),
    listId: uuidV4(),
    listName: getListName('LERE', pageSource, 'Sticky Footer'),
    ...(lereVersion ? { lere: { version: lereVersion } } : {}),
  }), [lereVersion, pageSource])

  const filters = useMemo(() => {
    if (lereOfferCheckIn && lereOfferCheckOut) {
      return {
        checkIn: lereOfferCheckIn,
        checkOut: lereOfferCheckOut,
      }
    }
    if (lereOfferCheckIn && lereOfferDuration) {
      return {
        checkIn: lereOfferCheckIn,
        checkOut: moment(lereOfferCheckIn, ISO_DATE_FORMAT).add(lereOfferDuration, 'days').format(ISO_DATE_FORMAT),
      }
    }
    return {}
  }, [lereOfferCheckIn, lereOfferCheckOut, lereOfferDuration])

  return (
    <TrackingContext.Provider value={stickyFooterTracking}>
      <YmalStickyFooter
        {...props}
        filters={filters}
      />
    </TrackingContext.Provider>
  )
}

function mapState(state: App.State, ownProps: OwnProps) {
  const { seedOffer } = ownProps
  const offerSharedState = state.recommendations.offerSharedState[seedOffer?.id]
  const offerBasedLereState = getOfferBasedLereState(
    state,
    seedOffer,
  )

  return {
    lereOfferCheckIn: offerSharedState?.checkIn,
    lereOfferCheckOut: offerSharedState?.checkOut,
    lereOfferDuration: offerSharedState?.duration,
    offerIds: offerBasedLereState.offerIds,
    currency: state.geo.currentCurrency,
    distanceUnit: getDistanceUnit(state),
    offerDetailsLoading: offerBasedLereState.loadingState === 'loading',
    loadingState: offerBasedLereState.loadingState,
    loadingError: null,
    lereVersion: offerBasedLereState.lereVersion,
    hasEnoughRecommendationsToDisplay: offerBasedLereState.hasEnoughRecommendationsToDisplay,
  }
}

export default connect(mapState)(OfferYmalStickyFooter)
